<template>
    <div class="expense-content">
        <el-card class="box-card">
            <div class="table-box">
                <div class="card-title">渠道名称:</div>
                <el-input v-model="header.channelName" class="handle-input" placeholder="请输入渠道名称"></el-input>
            </div>
            <div class="table-box">
                <div class="card-title">联系方式:</div>
                <el-input v-model="header.contact" class="handle-input" placeholder="请输入联系方式"></el-input>
            </div>
            <el-button type="primary" icon="el-icon-search">搜 索</el-button>
        </el-card>
        <el-card class="box-card mt20">
            <el-table
                :data="tableData"
                border
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
            >
                <el-table-column prop="userName" label="账户名称"></el-table-column>
                <el-table-column prop="phone" label="联系方式"></el-table-column>
                <el-table-column prop="userType" label="用户类型">
                    <template slot-scope="{row}">
                        <span v-if="row.userType === 1">普通用户</span>
                        <span v-if="row.userType === 2">公司用户</span>
                    </template>
                </el-table-column>
                <el-table-column prop="linkName" label="联系人"></el-table-column>
                <el-table-column prop="linkPhone" label="联系方式"></el-table-column>
                <el-table-column prop="email" label="电子邮箱"></el-table-column>
                <el-table-column prop="idCard" label="身份张信息"></el-table-column>
                <el-table-column label="营业执照">
                    <template slot-scope="{row}">
                        <span v-if="row.businessLicense == null">-</span>
                        <el-image
                            v-else
                            :src="row.businessLicense"
                            style="width: 50px; height: 50px; "
                        />
                    </template>
                </el-table-column>
                <el-table-column prop="enable" label="用户状态">
                    <template slot-scope="{row}">
                        <span v-if="row.enable == 1" style="color:#67C23A">用户已启用</span>
                        <span v-else style="color:#F56C6C">用户已停用</span>
                    </template>
                </el-table-column>
                <el-table-column prop="insertTime" label="创建时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="{row}">
                        <el-link type="primary" @click="getChannelDetail(row.id)">资源详情</el-link>
                    </template>
                </el-table-column>
                
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="query.currentPage"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="query.total">
                </el-pagination>
            </div>
        </el-card>
        <el-dialog title="渠道用户资源详情" :visible.sync="dialogChannelVisible" width="1000px">
            <el-card class="box-card">
                <div class="table-box">
                    <div class="card-title">资源名称:</div>
                    <el-input v-model="dialog.resourceName" class="handle-input" placeholder="请输入资源名称"></el-input>
                </div>
                <div class="table-box">
                    <div class="card-title">型号:</div>
                    <el-input v-model="dialog.model" class="handle-input" placeholder="请输入渠道名称"></el-input>
                </div>
                <div class="table-box">
                    <div class="card-title">组网:</div>
                    <el-input v-model="dialog.networking" class="handle-input" placeholder="请输入联系方式"></el-input>
                </div>
                <div class="table-box">
                    <div class="card-title">地点:</div>
                    <el-select class="handle-input" v-model="dialog.address" clearable placeholder="请选择地点">
                        <el-option
                            v-for="item in dialog.optionAddress"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <el-button type="primary" icon="el-icon-search">搜 索</el-button>
            </el-card>
            <el-table 
                :data="dialog.gridData"
                border
                class="mt20"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
                <el-table-column property="resourceName" label="资源名称"></el-table-column>
                <el-table-column property="model" label="型号"></el-table-column>
                <el-table-column property="networking" label="组网"></el-table-column>
                <el-table-column property="address" label="地点"></el-table-column>
                
                <el-table-column property="rentDate" label="计划租用时间"></el-table-column>
                <el-table-column  label="租用类型">
                    <template slot-scope="{row}">
                        <span v-if="row.rentType == 1">月租</span>
                        <span v-if="row.rentType == 2">年租</span>
                    </template>
                </el-table-column>
                <el-table-column property="resourceNum" label="租用数量"></el-table-column>
                <el-table-column label="租用时长">
                    <template slot-scope="{row}">
                        <span v-if="row.rentType == 1">{{row.timeLength}}个月</span>
                        <span v-if="row.rentType == 2">{{row.timeLength}}年</span>
                    </template>
                </el-table-column>
                <el-table-column property="unitPrice" label="资源单价"></el-table-column>
                <el-table-column label="订单状态">
                    <template slot-scope="{row}">
                        <span v-if="row.orderState == 1" style="color: #106eea;">对接中</span>
                        <span v-if="row.orderState == 2" style="color: #67C23A;">已完成</span>
                    </template>
                </el-table-column>
                
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogChannelVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogChannelVisible = false">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    channelUserList,
    channelUserDetail
} from '@/api/index'
export default {

    data() {
        return {
            header:{
                channelName:'',
                contact:''
            },
            tableData:[],
            query:{
                currentPage:1,
                pageSize:10,
                total:0,
            },
            dialogChannelVisible:false,
            channelId:"",
            dialog:{
                
                resourceName:'',
                model:'',
                networking:'',
                address:'',
                optionAddress:[
                    {
                        value: '北京',
                        label: '北京'
                    },{
                        value: '新疆',
                        label: '新疆'
                    },{
                        value: '青海',
                        label: '青海'
                    },{
                        value: '上海',
                        label: '上海'
                    },{
                        value: '广州',
                        label: '广州'
                    },{
                        value: '温州',
                        label: '温州'
                    },{
                        value: '郑州',
                        label: '郑州'
                    },{
                        value: '宁夏',
                        label: '宁夏'
                    },{
                        value: '廊坊',
                        label: '廊坊'
                    },{
                        value: '连云港',
                        label: '连云港'
                    },{
                        value: '金华',
                        label: '金华'
                    },{
                        value: '厦门',
                        label: '厦门'
                    },
                ],
                gridData:[],
                pageIndex:1,
                pageSize:10,
                total:0,
            }
        };
    },

    mounted() {
        this.getListData();
    },

    methods: {
        async getListData(){
            let data = {
                pageNum:this.query.currentPage,
                pageSize:this.query.pageSize,
                phone:this.header.contact,
                name:this.header.channelName,
            }
            const res = await channelUserList(data)
            if(res.success){
                this.tableData = res.data.records
                this.query.total = res.data.total
            }
        },
        handleSizeChange(val) {
            this.query.pageSize = val;
            this.getListData();
        },
        handleCurrentChange(val) {
            this.query.currentPage = val;
            this.getListData();
        },
        getChannelDetail(id){
            this.channelId = id;
            this.dialogChannelVisible = true;
            this.getChannelDetailData();
        },
        async getChannelDetailData(){
            let data = {
                pageNum:this.dialog.pageIndex,
                pageSize:this.dialog.pageSize,
                userId:this.channelId,
                address:this.dialog.address,
                model:this.dialog.model,
                networking:this.dialog.networking,
                resourceName:this.dialog.resourceName,
            }
            const res = await channelUserDetail(data);
            console.log(res);
            if(res.success){
                this.dialog.gridData = res.data.records
            }
        }
    },
};
</script>

<style scoped>
.expense-content{
    width:100%;
    height:auto;
    min-height:calc(100vh - 200px);
	padding:20px 20px;
	background-color: #f9fafb;
}
.table-box{
    display:inline-block;
    margin-right:10px;
}
.card-title{
    display:inline-block;
    margin-right:10px;
    font-size:14px;
    line-height:40px;
}
.handle-input{
    width:240px;
}

</style>